import { connect } from 'react-redux'
import densityCorrectionForm from '../ui/forms/densityCorrectionForm'
import { setDensityCorrection } from '../../store/actions/densityCorrectionActions'

const mapStateToProps = state => ({
    densityCorrectionValues: state.formulas.densityCorrection
})

const mapDispatchToProps = dispatch => {
    return {
        formToState: (val) => {
            dispatch(
                setDensityCorrection(val)
            )
        }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(densityCorrectionForm)